import { useTranslation } from "../../../../customHooks/useTranslation/index.js";
import { useTheme } from "styled-components";
import { Badge } from "waapi/waap-ui/components/Badge/Badge.js";
import { ITheme } from "waapi/waap-ui/components/Theme/Theme.types.js";
import { Text } from "waapi/waap-ui/components/Text/Text.js";
import { TextSize, TextWeight } from "waapi/waap-ui/components/Text/Text.types.js";
import { useEffect, useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { MenuItem } from "./MenuItem/index.js";
import { getSettingsSecondayMenuItems } from "./constants.js";
import { isSettingsSecondaryMenuPage } from "./helpers/isSettingsSecondaryMenuPage.js";
import { Container, MenuItems } from "./style.js";
import { SettingsSecondaryMenuPage } from "./types.js";

export const SettingsSecondaryMenu = (): JSX.Element => {
    const [selected, setSelected] = useState<SettingsSecondaryMenuPage>(SettingsSecondaryMenuPage.MY_ACCOUNT);

    const { pathname } = useLocation();
    const navigate = useNavigate();
    const { t, translations } = useTranslation();
    const theme = useTheme() as ITheme;

    const changeRoute = (route: string) => navigate(`/settings/${route}`);

    useEffect(() => {
        const contentsPathMatch = pathname.match(/\/settings\/(.*)/);

        if (contentsPathMatch && contentsPathMatch.length === 2 && isSettingsSecondaryMenuPage(contentsPathMatch[1])) {
            setSelected(contentsPathMatch[1]);
        }
        // eslint-disable-next-line
    }, [pathname]);

    const settingsSecondayMenuItems = getSettingsSecondayMenuItems({ t, translations, theme });

    return (
        <Container>
            <Text size={TextSize.LARGE} weight={TextWeight.BOLD}>
                {t(translations.sidebar.route.settings())}
            </Text>

            <MenuItems>
                {Object.keys(settingsSecondayMenuItems).map((page) => {
                    const pageProperties = settingsSecondayMenuItems[page];
                    const component = (
                        <MenuItem {...pageProperties} key={page} value={page} onClick={() => changeRoute(page)} selected={selected === page} />
                    );

                    return pageProperties.hasNotification ? (
                        <Badge key={page} color="error" variant="dark" yOffset="-0.5rem">
                            {component}
                        </Badge>
                    ) : (
                        component
                    );
                })}
            </MenuItems>
        </Container>
    );
};
